module.exports = __webpack_public_path__ + "static/media/layer1M.eb6268aa.png";